let isInitialized = false;

(function () {
    const languageSelector = document.getElementById("language-selector");
    if (languageSelector) {
        languageSelector.addEventListener("click", handleFirstClick);
    } else {
        console.error("Language selector element not found");
    }
})();

function handleFirstClick(event) {
    event.stopPropagation();

    if (isInitialized) return;
    isInitialized = true;

    const languageSelector = document.getElementById("language-selector");
    if (languageSelector) {
        languageSelector.removeEventListener("click", handleFirstClick);
        setupLanguageSelector();
        languageSelector.click();
    }
}

function setupLanguageSelector() {
    const elements = {
        container: document.getElementById("language-container"),
        selector: document.getElementById("language-selector"),
        dropdown: document.getElementById("language-dropdown"),
        chevron: document.querySelector("#language-selector .chevron-icon"),
        icon: document.querySelector("#language-selector .language-icon"),
        code: document.querySelector("#language-selector .language-code"),
        display: document.querySelector("#language-selector .language-display"),
    };

    if (!elements.container || !elements.selector || !elements.dropdown) {
        return;
    }

    elements.selector.addEventListener("click", function (event) {
        event.stopPropagation();
        toggleDropdown();
    });

    elements.selector.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleDropdown();
        } else if (event.key === "Escape") {
            closeDropdown();
        }
    });

    function toggleDropdown() {
        const isExpanded = elements.selector?.getAttribute("aria-expanded") === "true";

        if (isExpanded) {
            closeDropdown();
        } else {
            openDropdown();
        }
    }

    function openDropdown() {
        elements.dropdown?.classList.remove("hidden");
        elements.selector?.setAttribute("aria-expanded", "true");

        elements.selector?.classList.add("border-crimson-500", "rounded-t-xl");
        elements.selector?.classList.remove("border-iron-400", "rounded-xl");

        elements.chevron?.classList.add("rotate-180", "!text-crimson-500");
        elements.icon?.classList.add("!text-crimson-500");
        elements.code?.classList.add("!text-crimson-500");

        if (elements.display) {
            elements.display.classList.add("border-r-crimson-500");
            elements.display.classList.remove("border-r-iron-400");
        }

        document.addEventListener("click", handleOutsideClick);
    }

    function closeDropdown() {
        elements.dropdown?.classList.add("hidden");
        elements.selector?.setAttribute("aria-expanded", "false");

        elements.selector?.classList.remove("border-crimson-500", "rounded-t-xl");
        elements.selector?.classList.add("border-iron-400", "rounded-xl");

        elements.chevron?.classList.remove("rotate-180", "!text-crimson-500");
        elements.icon?.classList.remove("!text-crimson-500");
        elements.code?.classList.remove("!text-crimson-500");

        if (elements.display) {
            elements.display.classList.remove("border-r-crimson-500");
            elements.display.classList.add("border-r-iron-400");
        }

        document.removeEventListener("click", handleOutsideClick);
    }

    // Håndter klik udenfor dropdown
    function handleOutsideClick(event: MouseEvent): void {
        if (!elements.container?.contains(event.target as Node)) {
            closeDropdown();
        }
    }
}

let langSelector: HTMLElement | null = null;
let mobileContainer: HTMLElement | null = null;
let desktopContainer: HTMLElement | null = null;

function setupLangSelectorMove() {
    langSelector = document.getElementById("langSelector");
    mobileContainer = document.getElementById("langSelectorMobileContainer");
    desktopContainer = document.getElementById("langSelectorDesktopContainer");

    const moveLangSelector = () => {
        if (!langSelector || !mobileContainer || !desktopContainer) return;
        if (window.innerWidth < 768) {
            mobileContainer.appendChild(langSelector);
        } else {
            desktopContainer.appendChild(langSelector);
        }
    };

    moveLangSelector();

    window.addEventListener("resize", moveLangSelector);
}

document.addEventListener("DOMContentLoaded", setupLangSelectorMove);
